module.exports = __webpack_public_path__ + "static/media/equipo1 big.f9e8028c.png";